
<footer class="w-full pt-6 bg-background border-t">
    <div class="md:w-[70%] px-0 mx-auto py-6">
        <div class="grid sm:grid-cols-12 justify-center items-center">

            <div class="col-span-12 md:col-span-6 order-1 md:order-2 text-center mb-6 px-3 md:mb-0">
                <div class="rounded-2xl px-5 py-6 gap-1 bg-gray-100">
                    <h2 class="text-2xl brand-text mb-5 font-bold">Connect Us</h2>
                    <app-form></app-form>
                </div>
            </div>

            <div class="col-span-12 md:col-span-6 px-4 order-2 md:order-1">
                <img src="assets/image/header-img/img.png" alt="Logo" class="w-[150px] my-2">
                <p class="text-white mb-3 text-lg">
                    We’d love to hear from you! Whether you have questions, need support, or want to know more about our College Management System, feel free to reach out.
                </p>
                <ul class="list-unstyled w-full justify-between items-center py-2 text-[15px]">
                    <li class="py-1">
                        <a href="https://maps.app.goo.gl/6Eide73NRk5G3gZWA" target="_blank" class="text-white text-lg flex items-center">
                            <i class="fa-solid fa-location me-2 text-2xl"></i> 29/2, Vijay Enclave, Dwarka-Palam Road, Delhi-110045
                        </a>
                    </li>
                    <li class="py-3">
                        <a href="tel:+919310828501" class="text-white text-lg flex items-center">
                            <i class="fa-solid fa-mobile-screen me-2 text-2xl"></i> +91-9310828501
                        </a>
                    </li>
                    <li class="py-1">
                        <a href="mailto:support@volmint.com" class="text-white text-lg flex items-center">
                            <i class="fas fa-envelope me-2 text-2xl"></i>support@volmint.com
                        </a>
                    </li>
                </ul>
            </div>

        </div>
    </div>

    <div class="text-center border-t text-white py-3 md:py-3">
        <small>Copyright 2025. All rights reserved. Volmint Technologies Private Limited</small>
    </div>
</footer>
